import React from 'react';
import Servises from '../Servises/Servises';
import Slider from '../Slider/Slider';

const Home = () => {
   return (
      <div>
         <Slider></Slider>
         <Servises></Servises>
      </div>
   );
};

export default Home;